import { Datagrid, ListProps, TextField } from 'react-admin';
import { CustomList, SortableDatagridBody } from '../../components';
import ActiveField from '../../components/ActiveField';

export default function ResponsibilityItemsList(props: ListProps) {
  return (
    <CustomList 
      {...props}
      filter={{
        $limit: -1,
        $sort: 'position'
      }}
      pagination={false}
    >
      <Datagrid body={<SortableDatagridBody />} rowClick="edit">
        <TextField label="Título" source="title" sortable={false} />

        <ActiveField label="Ativo" />
      </Datagrid>
    </CustomList>
  );
}
